export interface DataEntity_Detail_11_01_Interface {
    id: number,
    main_id: number,
  
    reference_Value: string,

    uncertainty: string,
    converage: string,


  }
  
  export function Empty_DataEntity_Detail_11_01_Interface(): DataEntity_Detail_11_01_Interface {
    return {
      id: 0,
      main_id: 0,
  
      reference_Value: '',


      uncertainty: '',
      converage: '',


    }
  }
